import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";
import { PAROTTA_KADAI } from "../../../constants/Constants";
require("./booth.scss");

class ParottaKadai extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Parotta Kadai</div>
        <Card.Img
          className="booth-image"
          src="https://nbcf.s3-us-west-1.amazonaws.com/resonate/PRODUCT0302-H-Chicken-Parotta-new.jpg"
        />
        <Card.Title className="booth-text">ITEMS AVAILABLE</Card.Title>
        {PAROTTA_KADAI.map(items => (
          <Card.Text className="booth-item">{items}</Card.Text>
        ))}
      </div>
    );
  }
}

export default ParottaKadai;
